import { useState } from "react";
import { toast } from "sonner";
import { http, fail } from "@/adminApi";
import { DISPATCH_STEPS } from "@/TrackOrder";

export function OrderTrackingPanel({ order, onSaved }) {
  const [f, setF] = useState({
    dispatch_status: order.dispatch_status || "not_dispatched",
    expected_delivery: order.expected_delivery || "",
    tracking_notes: order.tracking_notes || "",
  });
  const [saving, setSaving] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const r = await http.put(`/admin/orders/${order.order_id}`, f);
      onSaved(r.data);
      toast.success(`Tracking updated for ${order.order_id}`);
    } catch (err) {
      fail(err);
    } finally {
      setSaving(false);
    }
  };
  return (
    <tr className="sizes-row">
      <td colSpan={8}>
        <form className="tracking-form" onSubmit={save} data-testid={`admin-tracking-form-${order.order_id}`}>
          <label>
            Dispatch status
            <select value={f.dispatch_status} onChange={(e) => setF({ ...f, dispatch_status: e.target.value })} data-testid={`admin-dispatch-${order.order_id}`}>
              {DISPATCH_STEPS.map(([k, label]) => (
                <option key={k} value={k}>
                  {label}
                </option>
              ))}
            </select>
          </label>
          <label>
            Expected delivery
            <input type="date" value={f.expected_delivery} onChange={(e) => setF({ ...f, expected_delivery: e.target.value })} data-testid={`admin-eta-${order.order_id}`} />
          </label>
          <label className="wide">
            Note for the customer (shown on Track My Order)
            <textarea maxLength={1000} value={f.tracking_notes} onChange={(e) => setF({ ...f, tracking_notes: e.target.value })} placeholder="e.g. Dispatched via BlueDart, AWB 1234567890" data-testid={`admin-notes-${order.order_id}`} />
          </label>
          <button className="btn btn-red admin-save" disabled={saving} data-testid={`admin-tracking-save-${order.order_id}`}>
            {saving ? "Saving…" : "Save tracking"}
          </button>
        </form>
      </td>
    </tr>
  );
}
